export default "__VITE_ASSET__eJOLaeVn__"